import { createSlice } from '@reduxjs/toolkit';

const initialState = { data: null, status: 'idle', error: null };

const inviteMemberSlice = createSlice({
  name: 'inviteMember',
  initialState,
  reducers: {
    inviteMemberRequest(state) {
      state.status = 'loading';
      state.error = null;
    },
    inviteMemberSuccess(state, action) {
      state.status = 'succeeded';
      state.data = action.payload;
    },
    inviteMemberFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    inviteMemberReset(state) {
      state.status = 'idle';
      state.error = null;
      state.data = null;
    },
  },
});

export const inviteMemberAction = inviteMemberSlice.actions;
export default inviteMemberSlice;